import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import drop_down_icon from "../../assets/icons/drop_down_icon.png";
import white_email_icon from "../../assets/icons/white_email_icon.png";
import white_whatsapp_icon from "../../assets/icons/white_whatsapp_icon.png";
import { Link } from "react-router-dom";

const CreateTask = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedEmail, setSelectedEmail] = useState("");
  const [selectedWhatsapp, setSelectedWhatsapp] = useState("");
  const [isToggled, setToggled] = useState(true);
  const [isQuickActionToggle, setIsQuickActionToggle] = useState(true);
  const [isActionToggle, setIsActionToggle] = useState(true);

  const handleToggle = () => {
    setToggled(!isToggled);
  };

  const handleQuickActionToggle = () => {
    setIsQuickActionToggle(!isQuickActionToggle);
  };
  const handleActionToggle = () => {
    setIsActionToggle(!isActionToggle);
  };
  return (
    <div className="flex flex-col w-full ">
      <SearchBar categoryName="Tasks" />
      <div className="ml-4 w-[70%] create-task">
        <div className="flex mt-4">
          <p className="text-[14px] mr-2">Assign to me</p>
          <div>
            <img src={drop_down_icon} alt="drop down" />
          </div>
        </div>
        <div className="mt-2">
          <p className="text-[14px]">Company/Store Name</p>
          <input
            type="text"
            placeholder="Please enter the company/store name"
            className="border w-full p-1 rounded-lg border-[#95C2FF] text-[16px]"
          />
        </div>
        <div className="bg-[#F8F8F8] p-4 mt-4 rounded-lg">
          <div className="flex justify-between">
            <p className="text-[12px]">Select Contact Person</p>
            <div className="text-[12px]">
              <label className="blue-slider-toggle">
                <input
                  type="checkbox"
                  checked={isToggled}
                  onChange={handleToggle}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
          <div className="mt-4">
            <p className="text-[14px]">Contact Person</p>
            <select
              name="Search & select contact person"
              className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
            >
              <option value="" disabled hidden>
                Search & select contact person
              </option>
              <option value="Praveen Sharma">Praveen Sharma</option>
            </select>
          </div>
        </div>

        {/* Task Title & Description */}
        <div className="mt-4">
          <p className="text-[14px]">Task Title</p>
          <input
            type="text"
            placeholder="Please enter the title for the task"
            className="border w-full p-1 rounded-lg border-[#95C2FF] text-[16px]"
          />
        </div>
        <div className="mt-4">
          <p className="text-[14px]">Description</p>
          <input
            type="text"
            placeholder="Enter the description here"
            className="border w-full p-1 rounded-lg border-[#95C2FF] text-[16px]"
          />
        </div>
        <div className="bg-[#F8F8F8] p-4 mt-4 rounded-lg">
          <div className="flex justify-between">
            <p className="text-[12px]">Quick Actions</p>
            <div className="text-[12px]">
              <label className="blue-slider-toggle">
                <input
                  type="checkbox"
                  checked={isQuickActionToggle}
                  onChange={handleQuickActionToggle}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>

          <div className="flex items-center mt-4">
            <img
              src={white_email_icon}
              alt="email"
              className="object-contain"
            />
            <div className="mt-4 w-full ml-2">
              <select
                name="Search & select contact person"
                className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
                value={selectedEmail}
                onChange={(e) => setSelectedEmail(e.target.value)}
              >
                <option value="" disabled hidden>
                  Search & select task
                </option>
                <option value="Praveen Sharma">Praveen Sharma</option>
              </select>
            </div>
          </div>
          {/*  */}
          <div className="flex items-center mt-4">
            <img
              src={white_whatsapp_icon}
              alt="whatsapp"
              className="object-contain"
            />
            <div className="mt-4 w-full ml-3">
              <select
                name="Search & select contact person"
                className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
                value={selectedWhatsapp}
                onChange={(e) => setSelectedWhatsapp(e.target.value)}
              >
                <option value="" disabled hidden>
                  Search & select task
                </option>
                <option value="Praveen Sharma">Praveen Sharma</option>
              </select>
            </div>
          </div>
        </div>

        <div className="bg-[#F8F8F8] p-4 mt-4 rounded-lg">
          <div className="flex justify-between">
            <p className="text-[12px] italic">Action</p>
            <div className="text-[12px]">
              <label className="blue-slider-toggle">
                <input
                  type="checkbox"
                  checked={isActionToggle}
                  onChange={handleActionToggle}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>

        <div className=" my-4 flex w-full justify-between items-center create-foot">
          <div className="text-[#2F80ED] text-[16px] underline font-bold cursor-pointer mt-8">
            Save & Create New
          </div>
          <div className="flex text-[14px] w-[50%] justify-end mt-8">
            <button className=" bg-white text-[#2F80ED] font-bold border border-[#95C2FF] p-2 rounded-lg w-[30%] action--buttons">
              Discard
            </button>
            <Link
              to="/tasks/customer-history"
              className="bg-[#2F80ED] ml-2 p-2 text-white rounded-lg w-[30%] text-center action--buttons cursor-pointer"
            >
              Send
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateTask;
